// Geography dropdown options for Site creation (TASK-003).
// Short lists focused on where BGC operates; typeahead still allows free text.

export const COUNTRIES: string[] = [
  'Canada',
  'United States',
  'Mexico',
  'Chile',
  'Peru',
  'Argentina',
  'Brazil',
  'Australia',
  'Papua New Guinea',
  'Mongolia',
  'Other',
];

export const CANADIAN_PROVINCES: string[] = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Northwest Territories',
  'Nunavut',
  'Yukon',
];

export const US_STATES: string[] = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming',
];

/** Returns suggested province/state list for a selected country; empty array = free text. */
export function provincesForCountry(country: string | null | undefined): string[] {
  if (country === 'Canada') return CANADIAN_PROVINCES;
  if (country === 'United States') return US_STATES;
  return [];
}
